/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs */

const en_admin_resource_form_fixed_rates_section_description = /** @type {(inputs: Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer this resource at a fixed rate, e.g. for half or full-day bookings.`)
};

const de_admin_resource_form_fixed_rates_section_description = /** @type {(inputs: Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biete einen Festpreis für diese Ressource an, z. B. für halb- oder ganztägige Buchungen.`)
};

const es_admin_resource_form_fixed_rates_section_description = /** @type {(inputs: Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofrece un precio fijo para este recurso, por ejemplo, para reservas de media jornada o de una jornada completa.`)
};

const fr_admin_resource_form_fixed_rates_section_description = /** @type {(inputs: Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offrez cette ressource à un prix fixe, par exemple pour des réservations d'une demi-journée ou d'une journée entière.`)
};

/** @type {(inputs: Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs) => LocalizedString} */
const it_admin_resource_form_fixed_rates_section_description = en_admin_resource_form_fixed_rates_section_description;

/** @type {(inputs: Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs) => LocalizedString} */
const pt_br2_admin_resource_form_fixed_rates_section_description = en_admin_resource_form_fixed_rates_section_description;

/** @type {(inputs: Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs) => LocalizedString} */
const pl_admin_resource_form_fixed_rates_section_description = en_admin_resource_form_fixed_rates_section_description;

/** @type {(inputs: Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs) => LocalizedString} */
const hu_admin_resource_form_fixed_rates_section_description = en_admin_resource_form_fixed_rates_section_description;

/** @type {(inputs: Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs) => LocalizedString} */
const ro_admin_resource_form_fixed_rates_section_description = en_admin_resource_form_fixed_rates_section_description;

/**
* | output |
* | --- |
* | "Offer this resource at a fixed rate, e.g. for half or full-day bookings." |
*
* @param {Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_fixed_rates_section_description = /** @type {((inputs?: Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Fixed_Rates_Section_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_fixed_rates_section_description(inputs)
	if (locale === "de") return de_admin_resource_form_fixed_rates_section_description(inputs)
	if (locale === "es") return es_admin_resource_form_fixed_rates_section_description(inputs)
	if (locale === "fr") return fr_admin_resource_form_fixed_rates_section_description(inputs)
	if (locale === "it") return it_admin_resource_form_fixed_rates_section_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_fixed_rates_section_description(inputs)
	if (locale === "pl") return pl_admin_resource_form_fixed_rates_section_description(inputs)
	if (locale === "hu") return hu_admin_resource_form_fixed_rates_section_description(inputs)
	return ro_admin_resource_form_fixed_rates_section_description(inputs)
});
export { admin_resource_form_fixed_rates_section_description as "admin.resource_form.fixed_rates_section_description" }